import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import ghaith from "../../Assets/Projects/ghaith.png";
import Horizon from "../../Assets/Projects/Horizon.png";
import grain from "../../Assets/Projects/grain.png";
import sweethome from "../../Assets/Projects/sweethome.png";
import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={grain}
              isBlog={false}
              title="Bakery Management System"
              description="Full-stack web application for managing bakery operations — connecting bakeries, production labs, delivery personnel, and admins in one unified platform.

Tech Stack
Frontend: Next.js 15, React 19, TypeScript, Tailwind CSS, Shadcn/UI
Backend: Node.js, Express.js, MongoDB, JWT Auth
Key Features
4 Role-Based Dashboards: Admin, Bakery, Laboratory, Delivery
Order Management: Full lifecycle tracking (Pending → In Progress → Ready → Delivered)
Production Tools: Lab queue management, Excel export for production sheets
Delivery System: Route management, order claiming, delivery tracking
Analytics: Sales charts, reports, invoice generation
UX: Dark/Light themes, responsive design, real-time notifications
Technical Highlights
RESTful API with role-based access control
Tax calculation system (HT/TTC pricing)
Excel report generation (ExcelJS)
TypeScript for full type safety"
              // ghLink="https://github.com/soumyajit4419/Plant_AI"
              demoLink="https://grained-artiste.com/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={sweethome}
              isBlog={false}
              title="Sweet Home - Real Estate Platform"
              description="Sweet Home is a full-stack real estate web application that enables users to browse, search, and book property tours while providing administrators with comprehensive property management capabilities.

Key Features
Property Listings: Browse properties with advanced filtering by location, type (apartment, house, villa, office, commercial, duplex, triplex), price range, and listing type (rent/sale)
Property Tour Booking: Schedule and manage property visits with time slot selection and booking status tracking
User Favorites: Save and manage favorite properties
Contact System: Integrated inquiry system for users to reach out about properties
Admin Dashboard: Full property management (CRUD), contact inquiries management, tour scheduling calendar, and user administration
Multi-language Support: Internationalization (i18n) ready with translation system
Image Upload: Multi-image upload support for property listings (up to 10 images)
Authentication: Secure JWT-based admin authentication with rate limiting
Tech Stack
Frontend:

Next.js (React Framework)
TypeScript
Tailwind CSS
Radix UI Components
Lucide Icons
React Hook Form
Backend:

Node.js & Express.js
MongoDB with Mongoose ODM
JWT Authentication
Multer (File Uploads)
Express Validator
Helmet & Rate Limiting (Security)
Architecture
RESTful API design
MVC pattern with Models, Routes, and Middleware
Responsive UI with dark/light theme support
Secure file handling with validation
"
              // ghLink="https://github.com/soumyajit4419/Plant_AI"
              demoLink="https://www.sweet-home.tn/"
            />
          </Col>

           <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ghaith}
              isBlog={false}
              title="Ghaith Nutrition"
              description="Ghaith Nutrition is a fully functional Shopify-based online store specializing in sports nutrition and dietary supplements aimed at fitness enthusiasts, athletes, and anyone focused on improving their health and performance. The site features a clean, user-friendly interface with categorized product listings such as whey protein, mass gainers, creatine, amino acids, vitamins & minerals, weight-loss products, accessories, and exclusive supplement packs — all presented with pricing, options, and add-to-cart functionality.

Built on Shopify, the platform supports seamless shopping experiences including multi-language (EN/FR) navigation, secure checkout, and responsive product browsing. It showcases featured products on the homepage and highlights the brand's ethos of quality, motivation, and performance enhancement through carefully curated nutrition products. The store also integrates social media links, customer engagement features, and professional messaging."
              demoLink="https://ghaithnutrition.com/"
            />
          </Col>
           <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Horizon}
              isBlog={false}
              title="Horizons World Trade Connections"
              description="Horizons World Trade Connections – Full-Stack Web Application

Horizons World Trade Connections is a full-stack web platform designed for an international trading company operating in import, export, and global supply chain services. The application presents the company’s services, product categories, and global reach through a modern, responsive interface while providing a powerful admin dashboard for internal management.

The frontend is built with React and TypeScript, ensuring a scalable, maintainable, and performant user experience. The website features a clean UI, responsive layouts, and structured sections showcasing the company’s mission, product offerings (agricultural commodities, food products, energy solutions), and contact information.

The backend is developed using Node.js with Express and MongoDB, providing a robust RESTful API for data management. The system includes authentication and authorization mechanisms to secure admin access.

An admin dashboard allows administrators to:

Manage website content dynamically

Add, edit, and delete products and categories

Handle business data stored in MongoDB

Control and update information without redeploying the frontend

The project follows a modern full-stack architecture, separating frontend and backend concerns, using TypeScript across the stack for type safety and long-term maintainability. It is designed to be scalable and adaptable for future business growth and additional features.

Technologies used:

React + TypeScript

Node.js + Express

MongoDB

REST API architecture

Admin dashboard with role-based access

This project demonstrates my ability to build production-ready full-stack applications, combining a polished public website with a secure and functional administrative system."
         
              demoLink="https://www.horizonswtc.com/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="PureNet (OX Medical) - E-commerce Platform"
              description="PureNet is a modern, full-stack e-commerce web application designed for a professional cleaning and medical supplies company. The platform enables customers to browse, search, and order premium cleaning products with seamless integration to Dolibarr ERP for real-time inventory and order management.

Key Features
Product Catalog – Dynamic product grid with category filtering, search functionality, and product detail modals
Shopping Cart – Fully functional cart system with quantity management using React Context API
Checkout System – Multi-step checkout supporting both individual and professional customers (with fiscal ID validation and automatic discounts)
ERP Integration – Real-time synchronization with Dolibarr ERP via REST API for customer management, order creation, and inventory tracking
Responsive Design – Mobile-first UI with modern animations and image carousels
Dark/Light Theme – Theme switching support using next-themes
Tech Stack
Frontend: Next.js 16, React 18, TypeScript
Styling: Tailwind CSS, Radix UI, shadcn/ui components
State Management: React Context API
Backend/API: Next.js API Routes, Dolibarr REST API integration
UI Components: Radix UI primitives, Lucide React icons, Embla Carousel
Form Handling: React Hook Form with Zod validation

Highlights
Built a complete B2B/B2C e-commerce flow from product browsing to order confirmation
Implemented Dolibarr ERP integration for automated customer creation, order processing, and invoice generation
Created a modular component architecture with 40+ reusable UI components
Developed real-time product image fetching from Dolibarr document management system
Added professional customer validation with fiscal ID (Matricule Fiscale) discount system
"
         
              demoLink="/under-development/purenet"
            />
          </Col>
         
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Edustrix"
              description="This project is a comprehensive school management system that aims to streamline administrative tasks, improve communication, and enhance the overall management of educational institutions. The system offers features such as managing teachers, students, subjects, schedules, and classrooms. It also includes the ability to track and update school data dynamically, manage the school calendar, and handle various forms and reports with ease. The frontend is built with React and integrates smoothly with a Node.js and MongoDB backend for robust data management. The system is designed to be user-friendly, efficient, and adaptable to the specific needs of the school."
              // ghLink="https://github.com/soumyajit4419/Chatify"
              demoLink="/confidential/edustrix"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="TunReview"
              description="This project is designed to streamline the process of managing and displaying reviews for various products or services. It allows users to submit, read, and interact with reviews, while providing an intuitive interface for both customers and administrators. The system includes features such as rating scales, detailed feedback submission, and the ability to sort or filter reviews based on different criteria. The project utilizes a robust backend built with Node.js and MongoDB, ensuring efficient storage and retrieval of review data. The frontend is built with React, providing a responsive and user-friendly experience. The reviews system is highly customizable and can be easily adapted to suit different industries, making it ideal for e-commerce platforms or service-based websites."
              // ghLink="https://github.com/soumyajit4419/Bits-0f-C0de"
              demoLink="https://blogs.soumya-jit.tech/"
            />
          </Col>

       

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="PitaApp"
              description="Pita is a mobile application built to bring pet lovers closer to their pets while enhancing the pet care experience. It serves as a one-stop solution for everything related to pet ownership, offering features to manage pet health, connect with fellow pet owners, and stay informed about pet-related news and services. Whether you're a pet owner looking for pet care services or someone who wants to connect with other pet lovers, Pita is designed to make it easy and enjoyable to care for your furry friends."
              // ghLink="https://github.com/soumyajit4419/Plant_AI"
              demoLink="https://plant49-ai.herokuapp.com/"
            />
          </Col>



        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
